export default function Conclusion() {
  const scrollToContact = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-black text-gray-900 mb-6">
              <strong className="text-primary">まとめ</strong>
            </h2>
          </div>
          
          <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-12 shadow-lg mb-12">
            <h3 className="text-3xl font-bold mb-8">Amazon自動化とは：</h3>
            <div className="space-y-6 text-xl">
              <div className="flex items-start gap-4">
                <i className="ri-close-line text-3xl mt-1"></i>
                <p className="line-through opacity-70">"作業を減らす"ことではありません。</p>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-check-line text-3xl mt-1"></i>
                <p className="font-bold text-2xl">"経営判断をリアルタイム化する"ことです。</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white border-2 border-primary rounded-2xl p-8 shadow-lg mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">私たちが提供するのは：</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <i className="ri-close-circle-line text-2xl text-gray-400 mt-1"></i>
                <p className="text-lg text-gray-500 line-through">単なるツールではなく</p>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-close-circle-line text-2xl text-gray-400 mt-1"></i>
                <p className="text-lg text-gray-500 line-through">一時的なノウハウでもなく</p>
              </div>
              <div className="flex items-start gap-4">
                <i className="ri-close-circle-line text-2xl text-gray-400 mt-1"></i>
                <p className="text-lg text-gray-500 line-through">スクリプトの提供でもありません。</p>
              </div>
              
              <div className="border-t-2 border-primary pt-6 mt-6">
                <div className="bg-primary/5 rounded-xl p-8 text-center">
                  <p className="text-2xl font-black text-primary mb-4">
                    Amazonで成長し続けるための<br />
                    「経営OS」そのものです。
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-primary text-white px-12 py-5 rounded-lg font-bold text-lg hover:bg-primary-dark transition-all hover:shadow-lg inline-flex items-center gap-3 whitespace-nowrap cursor-pointer group"
            >
              無料相談を申し込む
              <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
